// BNPL Services Data for Australia
export const bnplServices = [
  {
    id: 'beforepay',
    name: 'Beforepay',
    logo: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=200&h=100&fit=crop',
    website: 'https://www.beforepay.com.au',
    type: 'Cash Advance Service',
    tagline: 'Access your pay before payday',
    features: [
      'Pay Advance up to $2,000',
      'Transparent costs upfront',
      'Free budgeting tools',
      'No hidden fees'
    ],
    products: [
      {
        name: 'Pay Advance',
        description: 'Cash advance service',
        fixedFee: '5%',
        interestRate: 'Up to 24% p.a.',
        lateFee: 'Varies',
        repaymentPeriod: 'Next payday',
        maxAmount: '$2,000',
        noInterestOption: false
      },
      {
        name: 'Personal Loan',
        description: 'Higher limit lending',
        fixedFee: '5%',
        interestRate: '1.5% monthly (18% p.a.)',
        lateFee: 'Varies',
        repaymentPeriod: 'Monthly',
        maxAmount: 'Higher limits',
        noInterestOption: false
      }
    ],
    pros: [
      'Quick access to funds',
      'Transparent pricing',
      'Free budgeting app',
      'No credit check required'
    ],
    cons: [
      'Interest charges apply',
      'Not traditional BNPL',
      'Advance fees can add up',
      'Limited to cash advances'
    ],
    rating: 3.8,
    reviewCount: 1250
  },
  {
    id: 'afterpay',
    name: 'Afterpay',
    logo: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200&h=100&fit=crop',
    website: 'https://www.afterpay.com/en-AU',
    type: 'Buy Now Pay Later',
    tagline: 'Shop now, pay later in 4 instalments',
    features: [
      'Pay in 4 interest-free instalments',
      '98% of purchases have no late fees',
      'Available at 100,000+ stores',
      'Instant approval'
    ],
    products: [
      {
        name: 'Pay in 4',
        description: 'Standard BNPL service',
        fixedFee: '$0',
        interestRate: '0% (if paid on time)',
        lateFee: '$10 initially, +$7 after 1 week (max $68)',
        repaymentPeriod: '4 fortnightly payments',
        maxAmount: 'Varies by account',
        noInterestOption: true
      }
    ],
    pros: [
      'No interest if paid on time',
      'Widely accepted',
      'Easy to use',
      'Builds spending limit over time'
    ],
    cons: [
      'Late fees can accumulate',
      'May encourage overspending',
      'Credit card interest if used to pay',
      'Affects credit score if defaulted'
    ],
    rating: 4.2,
    reviewCount: 8500
  },
  {
    id: 'klarna',
    name: 'Klarna',
    logo: 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=200&h=100&fit=crop',
    website: 'https://www.klarna.com/au/',
    type: 'Buy Now Pay Later',
    tagline: 'Shop now, pay smarter',
    features: [
      'Pay in 4 or Pay in Full options',
      'No annual fees',
      'Grace period before late fees',
      'Shopping rewards program'
    ],
    products: [
      {
        name: 'Pay in 4',
        description: 'Interest-free instalments',
        fixedFee: '$0',
        interestRate: '0% (if paid on time)',
        lateFee: '$3-$7 (after 2-7 day grace period)',
        repaymentPeriod: '4 payments every 2 weeks',
        maxAmount: 'Varies by account',
        noInterestOption: true
      },
      {
        name: 'Pay Later',
        description: 'Extended payment terms',
        fixedFee: '$0',
        interestRate: '0-29.99% APR (varies)',
        lateFee: '$3-$7',
        repaymentPeriod: 'Flexible terms',
        maxAmount: 'Higher limits',
        noInterestOption: false
      }
    ],
    pros: [
      'Lower late fees than competitors',
      'Grace period before charges',
      'Multiple payment options',
      'Shopping rewards available'
    ],
    cons: [
      'Interest on extended plans',
      'Fewer retail partners in AU',
      'Approval not guaranteed',
      'Credit check may be required'
    ],
    rating: 4.0,
    reviewCount: 3200
  },
  {
    id: 'zip',
    name: 'Zip',
    logo: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=200&h=100&fit=crop',
    website: 'https://zip.co/au',
    type: 'Buy Now Pay Later',
    tagline: 'Own it now, pay later',
    features: [
      'Up to $1,000 credit limit',
      'Interest-free purchases',
      'Weekly, fortnightly or monthly payments',
      'Instant approval'
    ],
    products: [
      {
        name: 'Zip Pay',
        description: 'Interest-free BNPL',
        fixedFee: '$0',
        interestRate: '0% (interest-free)',
        lateFee: '$7.50 (7 days after due date)',
        repaymentPeriod: 'Flexible (min $10/week)',
        maxAmount: 'Up to $1,000',
        noInterestOption: true
      }
    ],
    pros: [
      'No interest on purchases',
      'Monthly fee waived if paid in full',
      'Flexible repayment schedule',
      'Widely accepted'
    ],
    cons: [
      '$9.95 monthly fee if balance remains',
      'BPAY fee ($2.50)',
      'Foreign exchange fees (3%)',
      'Smaller credit limit'
    ],
    rating: 4.1,
    reviewCount: 6800
  },
  {
    id: 'humm',
    name: 'Humm',
    logo: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?w=200&h=100&fit=crop',
    website: 'https://www.shophumm.com/au',
    type: 'Buy Now Pay Later',
    tagline: 'Big purchases, flexible terms',
    features: [
      'Up to $50,000 credit',
      '3-120 month payment plans',
      'Large purchase specialist',
      'Fortnightly or monthly payments'
    ],
    products: [
      {
        name: 'Humm BNPL',
        description: 'Regulated credit product',
        fixedFee: '$60-$80 establishment',
        interestRate: '0% (on approved plans)',
        lateFee: '$10/month (capped)',
        repaymentPeriod: '3-120 months',
        maxAmount: 'Up to $50,000',
        noInterestOption: true
      }
    ],
    pros: [
      'High credit limits',
      'Long payment terms available',
      'Interest-free options',
      'Suited for big-ticket items'
    ],
    cons: [
      '$8 monthly account fee',
      'Establishment fees apply',
      'Limited to partner merchants',
      'Fees can exceed purchase value'
    ],
    rating: 3.5,
    reviewCount: 2100
  },
  {
    id: 'latitudepay',
    name: 'Latitude Pay',
    logo: 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=200&h=100&fit=crop',
    website: 'https://www.latitudefinancial.com.au',
    type: 'Credit Card BNPL',
    tagline: 'Interest-free plans with credit cards',
    features: [
      'Interest-free promotional plans',
      'Multiple card options',
      'Up to 60 months interest-free',
      'Over 1 million customers'
    ],
    products: [
      {
        name: 'Latitude Gem Visa',
        description: 'Interest-free credit card',
        fixedFee: '$0',
        interestRate: '28.49% p.a. (after promo)',
        lateFee: '$45',
        repaymentPeriod: 'Up to 60 months promo',
        maxAmount: 'Varies by credit limit',
        noInterestOption: true
      }
    ],
    pros: [
      'Long interest-free periods',
      'Accepted everywhere',
      'Multiple card options',
      'Build credit history'
    ],
    cons: [
      '$10.95 monthly account fee',
      'High interest after promo period',
      'Late payment fees ($45)',
      'Multiple ongoing fees'
    ],
    rating: 3.6,
    reviewCount: 4500
  },
  {
    id: 'sezzle',
    name: 'Sezzle',
    logo: 'https://images.unsplash.com/photo-1563986768711-b3bde3dc821e?w=200&h=100&fit=crop',
    website: 'https://sezzle.com/au',
    type: 'Buy Now Pay Later',
    tagline: 'Pay in 4, always interest-free',
    features: [
      'Pay in 4 over 6 weeks',
      'Soft credit checks',
      'No interest ever',
      'Instant approval'
    ],
    products: [
      {
        name: 'Sezzle Pay in 4',
        description: 'Interest-free instalments',
        fixedFee: '$0',
        interestRate: '0% (always)',
        lateFee: '$10 failed payment',
        repaymentPeriod: '4 payments over 6 weeks',
        maxAmount: 'Varies by account',
        noInterestOption: true
      }
    ],
    pros: [
      'No interest ever',
      'Soft credit check only',
      'Quick approval',
      'Low failed payment fee'
    ],
    cons: [
      '$5 rescheduling fee (after 1st)',
      'Limited to 6-week terms',
      'Fewer retail partners',
      '$10 reactivation fee'
    ],
    rating: 4.2,
    reviewCount: 1800
  },
  {
    id: 'splitit',
    name: 'Splitit',
    logo: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200&h=100&fit=crop',
    website: 'https://www.splitit.com',
    type: 'Buy Now Pay Later',
    tagline: 'Use your credit card, pay over time',
    features: [
      'No credit checks',
      'No late fees',
      '3-36 month payment plans',
      'Uses existing credit card'
    ],
    products: [
      {
        name: 'Splitit Instalments',
        description: 'Credit card instalments',
        fixedFee: '$0 (from Splitit)',
        interestRate: '0% (from Splitit)',
        lateFee: '$0 (from Splitit)',
        repaymentPeriod: '3-36 months',
        maxAmount: 'Based on card limit',
        noInterestOption: true
      }
    ],
    pros: [
      'No fees from Splitit',
      'No credit checks',
      'Uses existing card',
      'Flexible terms up to 36 months'
    ],
    cons: [
      'Requires credit card',
      'Card interest may apply',
      'Limited merchant acceptance',
      'Funds held on card'
    ],
    rating: 4.0,
    reviewCount: 980
  },
  {
    id: 'openpay',
    name: 'Openpay',
    logo: 'https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=200&h=100&fit=crop',
    website: 'https://www.openpay.com.au',
    type: 'Buy Now Pay Later',
    tagline: 'Flexible plans for bigger purchases',
    features: [
      '2-24 month flexible plans',
      'Interest-free options',
      'Suited for larger purchases',
      'Merchant paid upfront'
    ],
    products: [
      {
        name: 'Openpay Plans',
        description: 'Flexible payment plans',
        fixedFee: '$0',
        interestRate: '0% (short-term plans)',
        lateFee: '$10/month (capped)',
        repaymentPeriod: '2-24 months',
        maxAmount: 'Varies by merchant',
        noInterestOption: true
      }
    ],
    pros: [
      'Flexible payment terms',
      'Interest-free short-term',
      'Good for big purchases',
      'Australian-owned'
    ],
    cons: [
      'Late fees apply',
      'Limited merchant network',
      'May require credit check',
      'Fewer consumer protections'
    ],
    rating: 3.7,
    reviewCount: 1200
  },
  {
    id: 'paypal',
    name: 'PayPal Pay in 4',
    logo: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=200&h=100&fit=crop',
    website: 'https://www.paypal.com/au/digital-wallet/ways-to-pay/buy-now-pay-later',
    type: 'Buy Now Pay Later',
    tagline: 'Most loved BNPL in Australia',
    features: [
      'No interest, no fees',
      'PayPal Buyer Protection',
      '$30-$2,000 purchase range',
      'Millions of retailers'
    ],
    products: [
      {
        name: 'Pay in 4',
        description: 'Interest-free instalments',
        fixedFee: '$0',
        interestRate: '0% (always)',
        lateFee: '$0',
        repaymentPeriod: '4 payments over 6 weeks',
        maxAmount: '$2,000',
        noInterestOption: true
      }
    ],
    pros: [
      'No late fees',
      'No sign-up fees',
      'Buyer Protection included',
      'Widely accepted'
    ],
    cons: [
      'Requires PayPal account',
      'Limited to $2,000',
      'May affect PayPal account standing',
      'Shorter repayment terms only'
    ],
    rating: 4.5,
    reviewCount: 12500
  },
  {
    id: 'laybuy',
    name: 'Laybuy',
    logo: 'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?w=200&h=100&fit=crop',
    website: 'https://www.laybuy.com',
    type: 'Buy Now Pay Later',
    tagline: 'Pay weekly, always interest-free',
    features: [
      '6 weekly payments',
      'Always interest-free',
      'Automatic payments',
      'Instant approval'
    ],
    products: [
      {
        name: 'Laybuy Weekly',
        description: '6 weekly instalments',
        fixedFee: '$0',
        interestRate: '0% (always)',
        lateFee: '$10 (capped at $10/month)',
        repaymentPeriod: '6 weekly payments',
        maxAmount: 'Varies by account',
        noInterestOption: true
      }
    ],
    pros: [
      'Always interest-free',
      'Weekly payment structure',
      'Low late fees',
      'Simple and transparent'
    ],
    cons: [
      'Limited to 6 weeks',
      'Smaller merchant network',
      'Late fees apply',
      'Less flexible terms'
    ],
    rating: 3.9,
    reviewCount: 780
  },
  {
    id: 'walletwizard',
    name: 'Wallet Wizard',
    logo: 'https://images.unsplash.com/photo-1556740714-a8395b3bf30f?w=200&h=100&fit=crop',
    website: 'https://www.walletwizard.com.au',
    type: 'Line of Credit',
    tagline: 'Smart loans, simple fees',
    features: [
      'Line of credit $500-$8,000',
      'No establishment fees',
      'No monthly service fees',
      'Flexible repayments'
    ],
    products: [
      {
        name: 'Smart Loan',
        description: 'Continuing credit line',
        fixedFee: '$0',
        interestRate: '47.8% p.a.',
        lateFee: '$1/day if overdue >14 days (max $100/year)',
        repaymentPeriod: 'Flexible (weekly/fortnightly/monthly)',
        maxAmount: '$8,000',
        noInterestOption: false
      }
    ],
    pros: [
      'No establishment or monthly fees',
      'Interest only on balance',
      'No early repayment penalties',
      'Instant approval (minutes)'
    ],
    cons: [
      'High 47.8% interest rate',
      'Arrears fee if late',
      'Expensive if not repaid quickly',
      'Not suited for long-term debt'
    ],
    rating: 3.4,
    reviewCount: 650
  },
  {
    id: 'fundo',
    name: 'Fundo',
    logo: 'https://images.unsplash.com/photo-1556740772-1a741367b93e?w=200&h=100&fit=crop',
    website: 'https://fundo.com.au',
    type: 'Small Loans',
    tagline: 'Fast, fair small loans',
    features: [
      'Loans $500-$5,000',
      'Same day funding',
      'Fundo Score rewards',
      'ASIC regulated'
    ],
    products: [
      {
        name: 'Small Loan',
        description: 'Quick cash loans',
        fixedFee: '20% establishment',
        interestRate: '0% (4% monthly fee)',
        lateFee: 'May apply',
        repaymentPeriod: '5 weeks to 9 months',
        maxAmount: '$2,000',
        noInterestOption: false
      },
      {
        name: 'Medium Loan',
        description: 'Larger amounts',
        fixedFee: '$400 establishment',
        interestRate: '47.8% p.a. (comp rate 63.29%)',
        lateFee: 'May apply',
        repaymentPeriod: '9 weeks to 9 months',
        maxAmount: '$5,000',
        noInterestOption: false
      }
    ],
    pros: [
      'Same day funding available',
      'Rewards for good behavior',
      'No hidden fees',
      'Easy online application'
    ],
    cons: [
      'High fees and interest',
      'Expensive for small amounts',
      'Short repayment terms',
      'Late payment charges'
    ],
    rating: 3.6,
    reviewCount: 1450
  },
  {
    id: 'borrowly',
    name: 'Borrowly',
    logo: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?w=200&h=100&fit=crop',
    website: 'https://www.borrowly.com.au',
    type: 'Personal Loans',
    tagline: 'Personal loans made simple',
    features: [
      'Loans $300-$15,000',
      'Tiered rate structure',
      'Quick online approval',
      'Same day funding'
    ],
    products: [
      {
        name: 'Small Loan',
        description: 'For smaller amounts',
        fixedFee: '20% establishment',
        interestRate: '4% monthly (comp rate 199.43%)',
        lateFee: 'Standard fees apply',
        repaymentPeriod: '3-12 months',
        maxAmount: '$2,000',
        noInterestOption: false
      },
      {
        name: 'Mid Loan',
        description: 'Mid-sized borrowing',
        fixedFee: '$400',
        interestRate: '48% p.a. (comp rate 66.07%)',
        lateFee: 'Standard fees apply',
        repaymentPeriod: '13-24 months',
        maxAmount: '$5,000',
        noInterestOption: false
      },
      {
        name: 'Large Loan',
        description: 'Bigger amounts',
        fixedFee: 'Included',
        interestRate: '21.24% APR (comp rate 48%)',
        lateFee: 'Standard fees apply',
        repaymentPeriod: '13-72 months',
        maxAmount: '$15,000',
        noInterestOption: false
      }
    ],
    pros: [
      'Wide loan range ($300-$15k)',
      'Longer terms for large loans',
      'Multiple lender matching',
      'Online application'
    ],
    cons: [
      'Very high rates for small loans',
      'Expensive compared to banks',
      'Rates vary by credit score',
      'High comparison rates'
    ],
    rating: 3.3,
    reviewCount: 890
  },
  {
    id: 'wagepay',
    name: 'WagePay',
    logo: 'https://images.unsplash.com/photo-1556741568-055d848f8bfd?w=200&h=100&fit=crop',
    website: 'https://www.wagepay.com.au',
    type: 'Earned Wage Access',
    tagline: 'Access your earned wages early',
    features: [
      'Access up to 25% of earned wages',
      'Maximum $3,000 advance',
      'No credit checks',
      'Funds in 60 seconds'
    ],
    products: [
      {
        name: 'Wage Advance',
        description: 'Early wage access',
        fixedFee: '5% of advance',
        interestRate: '24% p.a.',
        lateFee: '$0 (no late fees)',
        repaymentPeriod: 'Next payday (automatic)',
        maxAmount: '$3,000 (25% of wages)',
        noInterestOption: false
      }
    ],
    pros: [
      'No late fees',
      'No credit check',
      'Instant transfer (60 seconds)',
      'Tiered rewards system'
    ],
    cons: [
      '5% fee plus interest',
      'Only 25% of wages accessible',
      'Must be employed',
      'Can encourage overspending'
    ],
    rating: 3.8,
    reviewCount: 1100
  }
];

export const comparisonCategories = [
  {
    category: 'Interest & Fees',
    items: [
      {
        feature: 'Interest Rate',
        beforepay: 'Up to 24% p.a.',
        afterpay: '0% (on time)',
        klarna: '0% (Pay in 4)'
      },
      {
        feature: 'Fixed Fee',
        beforepay: '5%',
        afterpay: '$0',
        klarna: '$0'
      },
      {
        feature: 'Late Fee',
        beforepay: 'Varies',
        afterpay: '$10 + $7 (max $68)',
        klarna: '$3-$7'
      },
      {
        feature: 'Annual Fee',
        beforepay: '$0',
        afterpay: '$0',
        klarna: '$0'
      }
    ]
  },
  {
    category: 'Service Details',
    items: [
      {
        feature: 'Service Type',
        beforepay: 'Cash Advance',
        afterpay: 'BNPL Merchant',
        klarna: 'BNPL Merchant'
      },
      {
        feature: 'Payment Plan',
        beforepay: 'Next payday',
        afterpay: '4 fortnightly',
        klarna: '4 payments (2 weeks)'
      },
      {
        feature: 'Max Amount',
        beforepay: '$2,000',
        afterpay: 'Varies by account',
        klarna: 'Varies by account'
      },
      {
        feature: 'Approval Time',
        beforepay: 'Instant',
        afterpay: 'Instant',
        klarna: 'Instant'
      }
    ]
  },
  {
    category: 'Requirements',
    items: [
      {
        feature: 'Credit Check',
        beforepay: 'No',
        afterpay: 'Soft check',
        klarna: 'May require'
      },
      {
        feature: 'Min Age',
        beforepay: '18+',
        afterpay: '18+',
        klarna: '18+'
      },
      {
        feature: 'Income Required',
        beforepay: 'Yes',
        afterpay: 'Yes',
        klarna: 'Yes'
      },
      {
        feature: 'Bank Account',
        beforepay: 'Required',
        afterpay: 'Required',
        klarna: 'Required'
      }
    ]
  }
];

export const faqs = [
  {
    question: 'What is Buy Now Pay Later (BNPL)?',
    answer: 'BNPL is a short-term financing option that allows you to make purchases and pay for them over time, usually in interest-free instalments. Services like Afterpay and Klarna split your purchase into 4 equal payments.'
  },
  {
    question: 'How is Beforepay different from Afterpay and Klarna?',
    answer: 'Beforepay is a cash advance service that gives you access to your earned wages before payday, while Afterpay and Klarna are merchant-linked BNPL services. Beforepay charges a 5% fee plus interest, while Afterpay and Klarna are interest-free if you pay on time.'
  },
  {
    question: 'Are there any hidden fees?',
    answer: 'All three services are transparent about their fees. The main costs are late fees if you miss payments. Beforepay charges a fixed 5% fee plus interest, while Afterpay and Klarna are free if you pay on time but charge late fees ($10-$68 for Afterpay, $3-$7 for Klarna).'
  },
  {
    question: 'Which service is cheapest?',
    answer: 'If you pay on time, Afterpay and Klarna are free (0% interest, no fees). Beforepay charges a 5% fee plus interest, making it more expensive for the same purchase amount. However, Beforepay provides cash advances rather than merchant purchases.'
  },
  {
    question: 'Do these services affect my credit score?',
    answer: 'Beforepay typically does not check your credit. Afterpay performs a soft check. Klarna may require a credit check. Missing payments or defaulting can negatively impact your credit score with all services.'
  },
  {
    question: 'What happens if I miss a payment?',
    answer: 'Late fees apply: Afterpay charges $10 initially, then $7 more after a week (capped at $68). Klarna charges $3-$7 after a 2-7 day grace period. Beforepay\'s late fees vary. Your account may be suspended, and it could affect your credit score.'
  }
];